import { useContext } from 'react';
import UserContext from '../../../context/userContext';
import MostrarSociosAdmin from '../../Admin/Socios/MostrarSociosAdmin';
import MostrarSociosPost from '../../PostVenta/Socios/MostrarSociosPost';

export default function Socios() {
  const { user } = useContext(UserContext);

  switch (user.rol) {
    case 'ADMIN':
      return <MostrarSociosAdmin />;
    case 'POST':
      return <MostrarSociosPost />;
    default:
      return <MostrarSociosPost />;
  }
}
